import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class SettingsProvider {

  private theme: BehaviorSubject<String>;
  constructor(public http: Http) {
    console.log('Hello SettingsProvider Provider');
    this.theme=new BehaviorSubject('main-theme');
  }
  setActiveTheme(val){
    this.theme.next(val);
  }
  getActiveTheme(){
    return this.theme.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts